module.exports = __webpack_public_path__ + "img/activity_other10.5569564e.jpg";